import { useEffect, useState } from "react";
import { TimeSet } from "./OpeningHours";
import { updateStoreOpeningHours } from "../../../api/endpoints";
import { useDispatch } from "react-redux";
import { setStore } from "../../../slice/storeSlice";

const DifferentTimeAllWeek = ({ store, closeModal }) => {
  const [openTime, setOpenTime] = useState({
    monday: {
      from: "",
      to: "",
    },
    tuesday: {
      from: "",
      to: "",
    },
    wednesday: {
      from: "",
      to: "",
    },
    thursday: {
      from: "",
      to: "",
    },
    friday: {
      from: "",
      to: "",
    },
    saturday: {
      from: "",
      to: "",
    },
    sunday: {
      from: "",
      to: "",
    },
  });

  const [isFormValid, setIsFormValid] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    for (let day in openTime) {
      if (openTime[day].from === "" || openTime[day].to === "") {
        setIsFormValid(false);
        break;
      } else {
        setIsFormValid(true);
      }
    }
  }, [openTime]);

  const updateOpeningHours = async () => {
    let openingHours = openTime;

    try {
      let response = await fetch(updateStoreOpeningHours + store._id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(openingHours),
      });
      console.log(response);
      if (response.ok) {
        let store = await response.json();
        console.log(store);
        dispatch(setStore(store));
        closeModal(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className='differentTimeWrapper002'>
        <TimeSet id={"time4Up2731"} updateOpenTimeState={setOpenTime} openTimeState={openTime} fullDayOnpen={"monday"} day={"Mon"} />
        <TimeSet id={"time4Up2731232"} updateOpenTimeState={setOpenTime} openTimeState={openTime} fullDayOnpen={"tuesday"} day={"Tue"} />
        <TimeSet id={"time4Up273103je"} updateOpenTimeState={setOpenTime} openTimeState={openTime} fullDayOnpen={"wednesday"} day={"Wed"} />
        <TimeSet id={"time4Up2731475jf"} updateOpenTimeState={setOpenTime} openTimeState={openTime} fullDayOnpen={"thursday"} day={"Thur"} />
        <TimeSet id={"time4Up2731rinf7"} updateOpenTimeState={setOpenTime} openTimeState={openTime} fullDayOnpen={"friday"} day={"Fri"} />
        <TimeSet id={"time4Up2731kfn8"} updateOpenTimeState={setOpenTime} openTimeState={openTime} fullDayOnpen={"saturday"} day={"Sat"} color={"#4aaff3"} />
        <TimeSet id={"time4Up2731kfn8cssw"} updateOpenTimeState={setOpenTime} openTimeState={openTime} fullDayOnpen={"sunday"} day={"Sun"} color={"#4aaff3"} />
      </div>
      <div className='buttonDIvUpdateTime3'>
        <button onClick={() => closeModal(false)} className='btn-cancel2'>
          Cancel
        </button>
        {isFormValid ? (
          <button onClick={updateOpeningHours} className='btn-updateHours2'>
            Update Hours
          </button>
        ) : (
          <button className='btn-updateHours2' style={{ opacity: "0.7", cursor: "not-allowed" }} disabled>
            Update Hours
          </button>
        )}
      </div>
    </>
  );
};

export default DifferentTimeAllWeek;
